export const roleDisplayRef = {
  owner: 'Owner',
  admin: 'Admin',
  full: 'Full',
  read_only: 'Read Only',
};

export const disabledText = {
  accountAdd:
    'You do not have permission to create a new account from this account. Please contact your account administrator.',
  accountDelete: 'You are not authorized to delete this Account',
  accountEdit: 'You cannot edit Account details with this permission level',
  accountSettingsView:
    'You cannot view Account Settings with this permission level',
  addressAdd: 'You cannot add Addresses with this permission level',
  addressDelete:
    'You cannot delete Wallet Addresses with this permission level',
  addressView: 'You cannot view Wallet Addresses with this permission level',
  billingView: 'You do not have permission to manage billing',
  clientEdit: 'You cannot edit account details with this permission level',
  contactAdd: 'You cannot add Contacts with this permission level',
  contactDelete: 'You cannot delete Contacts with this permission level',
  contactEdit: 'You cannot edit Contact details with this permission level',
  contactView: 'You cannot view Contacts with this permission level',
  custodianDelete:
    'You cannot delete custodian connections with this permission level',
  integrationsEdit: 'You cannot edit integrations with this permission level',
  integrationsView: 'You cannot view integrations with this permission level',
  memoAdd: 'You cannot add memos with this permission level',
  memoDelete: 'You cannot delete memos with this permission level',
  memoEdit: 'You cannot edit memos with this permission level',
  reportCancel: 'You cannot cancel Reports with this permission level',
  reportCreate: 'You cannot create Reports with this permission level',
  reportDelete: 'You cannot delete Reports with this permission level',
  reportsView: 'You cannot view Reports with this permission level',
  sourceAdd: 'You cannot add Wallets with this permission level',
  sourceDelete: 'You cannot delete Wallets with this permission level',
  sourceEdit: 'You cannot edit Wallet details with this permission level',
  sourceView: 'You cannot view Wallets with this permission level',
  teamEdit: 'You do not have permissions to manage Team Members',
  teamView: 'You cannot view Team Members with this permission level',
  tmpUserDelete: 'You cannot cancel User invites with this permission level',
  tmpUserResend: 'You cannot resend User invites with this permission level',
  tmpUserView: 'You cannot view Requested Users with this permission level',
  txSearchView:
    'You cannot view transaction search features with this permission level',
  usageView: 'You cannot view account usage with this permission level',
  userAdd: 'You cannot add Account Users with this permission level',
  userDelete: 'You are not authorized to remove Account Users',
  userEdit: 'You are not authorized to change User Permission levels',
  userView: 'You cannot view Account Users with this permission level',
};

// Permissions object creation function
const rolePermissions = (addAccount = false, isAdminViewingClient = false) => ({
  owner: {
    role: 'Owner',
    isAdminViewingClient,
    accountSettingsView: true,
    accountAdd: addAccount,
    accountDelete: true,
    accountEdit: true,
    billingView: true,
    usageView: true,
    sourceView: true,
    sourceAdd: true,
    sourceDelete: true,
    sourceEdit: true,
    custodianDelete: true,
    addressView: true,
    addressAdd: true,
    addressDelete: true,
    reportsView: true,
    reportCreate: true,
    reportDelete: true,
    contactView: true,
    contactAdd: true,
    contactDelete: true,
    contactEdit: true,
    userView: true,
    userAdd: true,
    userEdit: true,
    userDelete: true,
    tmpUserView: true,
    tmpUserResend: true,
    tmpUserDelete: true,
    tmpUserUrls: true,
    txSearchView: true,
    integrationsEdit: true,
    integrationsDelete: true,
    integrationsView: true,
    teamView: true,
    teamEdit: true,
    clientEdit: true,
    clientDelete: true,
    disabledText,
    logsView: true,
    memoAdd: true,
    memoEdit: true,
    memoDelete: true,
  },
  admin: {
    role: 'Admin',
    isAdminViewingClient,
    accountSettingsView: true,
    accountAdd: addAccount,
    accountDelete: false,
    accountEdit: true,
    billingView: false,
    usageView: true,
    sourceView: true,
    sourceAdd: true,
    sourceDelete: true,
    sourceEdit: true,
    custodianDelete: true,
    addressView: true,
    addressAdd: true,
    addressDelete: true,
    reportsView: true,
    reportCreate: true,
    reportDelete: true,
    contactView: true,
    contactAdd: true,
    contactDelete: true,
    contactEdit: true,
    userView: true,
    userAdd: true,
    userEdit: true,
    userDelete: true,
    tmpUserView: true,
    tmpUserResend: true,
    tmpUserDelete: true,
    tmpUserUrls: true,
    txSearchView: true,
    integrationsEdit: true,
    integrationsDelete: true,
    integrationsView: true,
    teamView: true,
    teamEdit: true,
    clientEdit: true,
    clientDelete: true,
    disabledText,
    logsView: true,
    memoAdd: true,
    memoEdit: true,
    memoDelete: true,
  },
  full: {
    role: 'Full',
    isAdminViewingClient,
    accountSettingsView: true,
    accountAdd: addAccount,
    accountDelete: false,
    accountEdit: false,
    billingView: false,
    usageView: true,
    sourceView: true,
    sourceAdd: true,
    sourceDelete: true,
    sourceEdit: true,
    custodianDelete: true,
    bitgoCxDelete: true,
    addressView: true,
    addressAdd: true,
    addressDelete: true,
    reportsView: true,
    reportCreate: true,
    reportDelete: true,
    contactView: true,
    contactAdd: true,
    contactDelete: true,
    contactEdit: true,
    userView: false,
    userAdd: false,
    userEdit: false,
    userDelete: false,
    tmpUserView: false,
    tmpUserResend: false,
    tmpUserDelete: false,
    tmpUserUrls: false,
    txSearchView: true,
    integrationsEdit: true,
    integrationsDelete: true,
    integrationsView: true,
    teamView: true,
    teamEdit: false,
    clientEdit: true,
    clientDelete: false,
    disabledText,
    logsView: true,
    memoAdd: true,
    memoEdit: true,
    memoDelete: true,
  },
  read_only: {
    role: 'Read Only',
    isAdminViewingClient,
    accountSettingsView: true,
    accountAdd: addAccount,
    accountDelete: false,
    accountEdit: false,
    billingView: false,
    usageView: true,
    sourceView: true,
    sourceAdd: false,
    sourceDelete: false,
    sourceEdit: false,
    custodianDelete: false,
    addressView: true,
    addressAdd: false,
    addressDelete: false,
    reportsView: true,
    reportCreate: true,
    reportDelete: false,
    contactView: true,
    contactAdd: false,
    contactDelete: false,
    contactEdit: false,
    userView: false,
    userAdd: false,
    userEdit: false,
    userDelete: false,
    tmpUserView: false,
    tmpUserResend: false,
    tmpUserDelete: false,
    tmpUserUrls: false,
    txSearchView: true,
    integrationsEdit: false,
    integrationsDelete: false,
    integrationsView: true,
    teamView: true,
    teamEdit: false,
    clientEdit: false,
    clientDelete: false,
    disabledText,
    logsView: false,
    memoAdd: false,
    memoEdit: false,
    memoDelete: false,
  },
});

export const generateClientPermissions = ({
  addAccount = false,
  isAdminViewingClient = false,
  role = 'read_only',
  isOwner = false,
}) =>
  rolePermissions(addAccount, isAdminViewingClient)[isOwner ? 'owner' : role];
